import { Link } from 'react-router-dom'

interface StoreCardProps {
  id: string
  name: string
  address: string
  zona?: string
  coverage_km?: number
  has_delivery: boolean
  phone?: string
}

export function StoreCard({ id, name, address, zona, coverage_km, has_delivery, phone }: StoreCardProps) {
  return (
    <Link to={`/tiendas/${id}`} className="store-card">
      <div className="store-card-top">
        <div className="store-card-icon">🔧</div>
        <div className="store-card-body">
          <h3 className="store-card-name">{name}</h3>
          <p className="store-card-address">
            {address}
            {zona ? `, Zona ${zona}` : ''}
          </p>
        </div>
      </div>
      <div className="store-card-footer">
        {has_delivery ? (
          <span className="badge badge-green">🚚 Delivery {coverage_km ?? '?'} km</span>
        ) : (
          <span className="badge badge-gray">🏪 Solo en tienda</span>
        )}
        {phone && (
          <span className="store-card-phone">📱 {phone}</span>
        )}
      </div>
    </Link>
  )
}
